// extracted by mini-css-extract-plugin
export default {"logoContainer":"logocontainer_logoContainer__eTFQF","actionButton":"logocontainer_actionButton__Bukg-","logo":"logocontainer_logo__9TUW2","detalks":"logocontainer_detalks__A7agA"};